import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ThemeToggle from '../ThemeToggle';
import appIcon from '../../assets/brand/app-icon.png';

export default function AuthSplitShell({
  children,
  image,
  kicker = 'Households across Malawi',
  headline,
  caption,
}) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="relative hidden lg:block overflow-hidden min-h-screen">
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F2E2B] via-[#0F2E2B]/55 to-[#0F2E2B]/20" />
        <div className="absolute top-8 left-8 flex items-center gap-3 text-white">
          <img src={appIcon} alt="" className="w-10 h-10 rounded-xl" />
          <span className="font-bold text-lg">SmartPay</span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-10 text-white">
          <p className="text-[#99E1D9] font-semibold text-sm uppercase tracking-wider mb-2">{kicker}</p>
          <h2 className="text-3xl font-extrabold leading-tight max-w-md">{headline}</h2>
          {caption && <p className="mt-3 text-white/80 max-w-md">{caption}</p>}
        </div>
      </div>
      <div className="relative flex flex-col min-h-screen">
        <div className="flex items-center justify-between p-4 sm:p-6">
          <Link to="/welcome" className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
          <div className="flex items-center gap-2">
            <img src={appIcon} alt="" className="w-8 h-8 rounded-lg lg:hidden" />
            <ThemeToggle />
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center px-4 pb-10">
          <div className="w-full max-w-md">{children}</div>
        </div>
      </div>
    </div>
  );
}
